export default "__VITE_ASSET__r36Nxeiu__"